enum OrderCategory {
  FTTH = 'FTTH',
  FIBER_PREP = 'FIBER_PREP',
  ADDUCTION = 'ADDUCTION'
}

export default OrderCategory;
